import { Component, OnInit, OnChanges, Input, Output, SimpleChanges, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { EChartsOption, EChartsType } from 'echarts';

@Component({
    selector: 'app-echarts-renderer',
    templateUrl: './echarts-renderer.component.html',
    styleUrls: ['./echarts-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EchartsRendererComponent implements OnInit, OnChanges {

  @Input() options: EChartsOption;
  @Input() size?: {width?: number, height?: number};
  @Output() clicked = new EventEmitter<any>();

  echartsInstance: any;

  constructor() {}

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.renderCharts();
    }
  }

  /************************************** CHARTS *************************************************/

  onChartInit(instance: EChartsType){
    this.echartsInstance = instance;
    if(this.size) this.resize(this.size.width, this.size.height);
    this.echartsInstance.on('click', (params) => {
      this.clicked.emit(params.data);
    });
  }

  renderCharts(){
    this.echartsInstance?.setOption(this.options);
  }

  resize(width?: number, height?: number){
    this.echartsInstance?.resize({
      width: width,
      height: height
    })
  }
}
